import { SavedQuery } from '@/types';
import React from 'react';
import Column from '@/util/Column';
import { Dropdown, DropdownItem, DropdownList } from '@trevor/ui-components';
import convertColumnTypeToDisplayName from '@/util/ColumnTypeToDisplayNameConverter';
import { TSavedQueryPreset } from './types';
import { useGetColumns } from './useGetColumns';
import {
  ColumnType,
  SavedQueryConfigurationContainer,
  SelectedButton,
} from './PresetChoices.styles';

export type SavedQueryConfigurationProps = {
  reset: F0;
  savedQuery: SavedQuery;
  setSavedQueryPresets: F<TSavedQueryPreset>;
  savedQueryPresets: Maybe<TSavedQueryPreset>;
};
export const SavedQueryConfiguration: React.FC<
  SavedQueryConfigurationProps
> = ({ reset, savedQuery, setSavedQueryPresets, savedQueryPresets }) => {
  const columns = useGetColumns(savedQuery.series);

  const preselectedColumn =
    columns?.find(
      (c: any) =>
        c._name._name === savedQueryPresets?.columnName?._name &&
        c._name._alias === savedQueryPresets?.columnName?._alias,
    ) ?? null;

  return (
    <SavedQueryConfigurationContainer>
      <SelectedButton onClick={reset}>
        <b>{savedQuery.name}</b>
        <span>×</span>
      </SelectedButton>

      {columns && (
        <ColumnSelect
          columns={columns}
          savedQuery={savedQuery}
          setSavedQueryPresets={setSavedQueryPresets}
          preselectedColumn={preselectedColumn}
        />
      )}
    </SavedQueryConfigurationContainer>
  );
};

const ColumnSelect: React.FC<any> = ({
  columns,
  savedQuery,
  setSavedQueryPresets,
  preselectedColumn,
}) => {
  const [selectedColumn, setSelectedColumn] =
    React.useState<Maybe<Column>>(preselectedColumn);

  const handleColumnSelect = (column: any) => {
    setSelectedColumn(column);
    setSavedQueryPresets({
      seriesId: savedQuery.series,
      columnName: column._name,
    });
  };

  const handleColumnReset = () => {
    setSelectedColumn(null);
    setSavedQueryPresets({
      seriesId: savedQuery.series,
      columnName: null,
    });
  };

  return (
    <Dropdown>
      <Dropdown.Trigger>
        {selectedColumn ? (
          <SelectedButton onClick={handleColumnReset}>
            <b>{selectedColumn._name._name}</b>{' '}
            <ColumnType>
              {convertColumnTypeToDisplayName(selectedColumn._type._type)}
            </ColumnType>
            <span>×</span>
          </SelectedButton>
        ) : (
          <SelectedButton>
            Select a column <span className="caret" />
          </SelectedButton>
        )}
      </Dropdown.Trigger>
      <Dropdown.Content top={36}>
        <DropdownList>
          {columns
            ?.filter((column: Column) =>
              ['UUID', 'STRING', 'INT'].includes(column._type._type),
            )
            .map((column: Column) => (
              <DropdownItem
                key={`${column._name._alias}.${column._name._name}`}
                onClick={() => handleColumnSelect(column)}
              >
                {column._name._name}{' '}
                <ColumnType>
                  {convertColumnTypeToDisplayName(column._type._type)}
                </ColumnType>
              </DropdownItem>
            ))}
        </DropdownList>
      </Dropdown.Content>
    </Dropdown>
  );
};
